<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Kilometer</ion-title>
    <ion-buttons slot="end">
      <ion-button
        (click)="save()"
        [disabled]="!this.mileageForm.valid"
        [strong]="true"
        >Speichern</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form
    [formGroup]="mileageForm"
    class="bg-iosbackground dark:bg-transparent pt-5"
  >
    <ion-list>
      <ion-list-header class="pb-2">
        <ion-label>
          Kilometerstand Anfang und Ende
        </ion-label>
      </ion-list-header>
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="speedometer-outline"
            class="text-lg -mt-12"
          ></ion-icon>
        </ion-note>
        <ion-input
          type="number"
          formControlName="start_mileage"
          placeholder="Kilometerstand Anfang"
        ></ion-input>
        <ion-text slot="end">km</ion-text>
      </ion-item>
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="speedometer-outline"
            class="text-lg -mt-12"
          ></ion-icon>
        </ion-note>
        <ion-input
          type="number"
          formControlName="end_mileage"
          placeholder="Kilometerstand Ende"
        ></ion-input>
        <ion-text slot="end">km</ion-text>
      </ion-item>
    </ion-list>
    <ion-item-divider class="mt-6">
      <ion-label>Gesamt</ion-label>
    </ion-item-divider>
    <ion-list lines="none">
      <ion-item>
        <ion-text class="text-md">Gefahrene Kilometer</ion-text>
        <ion-text class="text-md" slot="end"
          >{{ (mileageForm.get('end_mileage').value && mileageForm.get('start_mileage').value) ? (mileageForm.get('end_mileage').value - mileageForm.get('start_mileage').value) : '0' }} km</ion-text
        >
      </ion-item>
    </ion-list>
  </form>
</ion-content>
